import React from 'react';
import { heavyLogWarningText, isHeavyLogCount } from '../heavyLogGate';

interface HeavyLogWarningProps {
    logCount: number;
}

const HeavyLogWarning: React.FC<HeavyLogWarningProps> = ({ logCount }) => {
    if (!isHeavyLogCount(logCount)) {
        return null;
    }

    return (
        <div className="log-count-warning" role="status">
            {heavyLogWarningText(logCount)}
        </div>
    );
};

export default HeavyLogWarning;
